// src/components/conversations/QuickPreviewModal.js
import React from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, Typography, Box, IconButton, Link as MuiLink,
  Divider, Stack, Grid // MOVED Grid import here
} from '@mui/material';
import { Close as CloseIcon, OpenInNew as OpenInNewIcon, PersonOutline as AgentIcon } from '@mui/icons-material';
import { formatDisplayDate, getConversationPreview } from '../../utils/conversationUtils';
import { Link as RouterLink } from 'react-router-dom';

const QuickPreviewModal = ({ open, onClose, conversation, onNavigateToListParams }) => {
  if (!conversation) return null;

  const previewText = getConversationPreview(conversation);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth PaperProps={{sx: {borderRadius: 2}}}>
      <DialogTitle sx={{ py: 1.5, px: 2}}>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Typography variant="h6" component="span">
              Conversation Quick View
          </Typography>
          <IconButton onClick={onClose} size="small" sx={{ml:1}}>
            <CloseIcon />
          </IconButton>
        </Stack>
      </DialogTitle>
      <Divider />
      <DialogContent sx={{pt: 2, px: 2}}>
        <Stack spacing={1.5}>
          <Box>
            <Typography variant="caption" color="text.secondary" display="block" sx={{fontWeight:500}}>
              CONVERSATION ID
            </Typography>
            <Typography variant="body2" sx={{fontSize: '0.9rem'}}>
              {conversation.id}
            </Typography>
          </Box>

          {conversation.agent_name && (
            <Box>
              <Typography variant="caption" color="text.secondary" display="block" sx={{fontWeight:500}}>
                AGENT
              </Typography>
              <Stack direction="row" alignItems="center" spacing={0.5}>
                 <AgentIcon sx={{ fontSize: '1rem', color: 'text.secondary' }}/>
                 <Typography variant="body2" sx={{fontSize: '0.9rem'}}>{conversation.agent_name}</Typography>
              </Stack>
            </Box>
          )}

          <Grid container spacing={1}>
            <Grid item xs={6}>
                <Typography variant="caption" color="text.secondary" display="block" sx={{fontWeight:500}}>
                CREATED
                </Typography>
                <Typography variant="body2" sx={{fontSize: '0.9rem'}}>
                {formatDisplayDate(conversation.created_at)}
                </Typography>
            </Grid>
            <Grid item xs={6}>
                <Typography variant="caption" color="text.secondary" display="block" sx={{fontWeight:500}}>
                LAST UPDATED
                </Typography>
                <Typography variant="body2" sx={{fontSize: '0.9rem'}}>
                {formatDisplayDate(conversation.updated_at)}
                </Typography>
            </Grid>
          </Grid>
        </Stack>

        <Divider sx={{my:2}}/>
        <Typography variant="subtitle2" gutterBottom sx={{fontWeight: 500}}>
            FIRST MESSAGE PREVIEW
        </Typography>
        <Box
          sx={{
            maxHeight: '150px',
            overflowY: 'auto',
            whiteSpace: 'pre-wrap',
            p: 1.5,
            bgcolor: (theme) => theme.palette.mode === 'dark' ? theme.palette.grey[800] : theme.palette.grey[100],
            borderRadius: 1,
            border: (theme) => `1px solid ${theme.palette.divider}`,
            fontSize: '0.9rem'
          }}
        >
          {previewText || 'No preview available.'}
        </Box>
      </DialogContent>
      <Divider />
      <DialogActions sx={{p:1.5, px:2}}>
        <Button onClick={onClose} color="inherit" variant="outlined" size="small">
          Close
        </Button>
        <Button
          variant="contained"
          color="primary"
          component={RouterLink}
          to={`/conversations/${conversation.id}`}
          state={{ listParams: onNavigateToListParams }}
          onClick={onClose} // Close modal when navigating
          startIcon={<OpenInNewIcon />}
          size="small"
        >
          View Full Conversation
        </Button>
      </DialogActions>
    </Dialog>
  );
};
// import Grid from '@mui/material/Grid'; // REMOVED from here

export default QuickPreviewModal;